<template lang="html">
  <div id="blog-detail-page" class="bg-white">
    <!-- Breadcrumb -->
    <div class="bg-light py-2 py-lg-3">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0 bg-transparent p-0">
            <li class="breadcrumb-item">
              <router-link to="/" class="text-secondary">Inicio</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/blog" class="text-secondary">Blog</router-link>
            </li>
            <!-- <li class="breadcrumb-item active" aria-current="page">{{{ post.category }}}</li> -->
          </ol>
        </nav>
      </div>
    </div>

    <loading-component-s1 v-if="isLoading"></loading-component-s1>

    <article class="container pt-3 pb-5" v-if="!isLoading">
      <!-- Botón volver -->
      <router-link to="/blog" class="d-inline-flex align-items-center text-secondary mb-3 text-decoration-none">
        <i class="fa-solid fa-arrow-left mr-2"></i>
        Volver al blog
      </router-link>

      <!-- Encabezado del artículo -->
      <header class="mb-4">
        <!-- <span class="badge badge-danger mb-3">{{ article.category }}</span> -->
        <h1 class="h2 font-weight-bold text-dark mb-4">{{ article.title }}</h1>

        <div class="d-flex flex-wrap align-items-center text-muted mb-4">
          <div class="d-flex align-items-center mr-4 mb-2 mb-md-0">
            <i class="fa-solid fa-user mr-2"></i>
            <div>
              <span class="font-weight-bold text-dark">{{ article.author }}</span>
              <span class="text-muted small ml-2">{{ article.author_specialty }}</span>
            </div>
          </div>
          <div class="d-flex align-items-center mr-4 mb-2 mb-md-0">
            <i class="fa-solid fa-calendar-alt mr-2"></i>
            <span>{{ article.date }}</span>
          </div>
          <!-- <div class="d-flex align-items-center mb-2 mb-md-0">
            <i class="fa-solid fa-clock mr-2"></i>
            <span>{{ post.readTime }}</span>
          </div> -->
        </div>

        <!-- <div class="mb-4">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            @click="showShareModal = true"
          >
            <i class="fa-solid fa-share-alt mr-2"></i>
            Compartir
          </button>
        </div> -->
      </header>

      <!-- Imagen destacada -->
      <div class="mb-4 rounded overflow-hidden">
        <img
          :src="article.image || 'public/images/shared/placeholder.svg'"
          :alt="article.title"
          class="img-fluid w-100"
        />
      </div>

      <!-- Contenido del artículo -->
      <div class="blog-detail-content mb-4" v-html="article.body"></div>

      <!-- Sección Compartir -->
      <!-- <div class="border-top pt-5 mb-5">
        <h3 class="h5 font-weight-bold text-dark mb-4">Compartir este artículo</h3>
        <div class="d-flex flex-wrap">
          <button type="button" class="btn btn-outline-secondary btn-sm mr-2 mb-2">
            <i class="fa-brands fa-facebook mr-2 text-primary"></i>
            Facebook
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm mr-2 mb-2">
            <i class="fa-brands fa-twitter mr-2 text-info"></i>
            Twitter
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm mr-2 mb-2">
            <i class="fa-brands fa-linkedin mr-2 text-primary"></i>
            LinkedIn
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm mb-2">
            <i class="fa-solid fa-envelope mr-2 text-secondary"></i>
            Email
          </button>
        </div>
      </div> -->

      <!-- Bio del autor -->
      <div class="bg-light rounded p-4 mb-5">
        <div class="d-flex">
          <div class="flex-shrink-0 bg-danger rounded-circle d-flex align-items-center justify-content-center text-white font-weight-bold mr-4" style="width: 4rem; height: 4rem; font-size: 1.5rem;">
            {{ article.author.charAt(0) }}
          </div>
          <div>
            <h4 class="h5 font-weight-bold text-dark mb-1">{{ article.author }}</h4>
            <p class="text-danger mb-2">{{ article.author_specialty }}</p>
            <!-- <p class="text-muted small mb-0">
              Experto en tecnología de medición con más de 10 años de experiencia en la industria.
              Apasionado por compartir conocimiento y ayudar a profesionales a aprovechar al máximo
              sus equipos topográficos.
            </p> -->
          </div>
        </div>
      </div>

      <!-- Artículos relacionados -->
      <div v-if="relatedArticles.length > 0" class="mb-5">
        <h3 class="h4 font-weight-bold text-dark mb-4">Otros artículos de interés</h3>
        <div class="row">
          <div
            v-for="(related, rkey) in relatedArticles"
            :key="'rkey-'+rkey"
            class="col-12 col-md-6 mb-4 col-article-card-s1"
          >
            <router-link :to="'/blog/' + $root._converToURL(related.title, related.id)" class="text-decoration-none text-body hover-border-danger">
              <div class="card border-0 shadow h-100 blog-card">
                <div class="position-relative overflow-hidden rounded-top">
                  <img
                    v-bind:style="{ backgroundImage: 'url('+( related.image || 'public/images/shared/placeholder.svg' )+')' }"
                    src="public/images/pages/blog/blog.png"
                    :alt="related.title"
                    class="card-img-top placed-backg blog-card-img featured-img"
                  />
                  <!-- <span class="badge badge-danger position-absolute m-3">{{ related.category }}</span> -->
                </div>
                <div class="card-body">
                  <h3 class="t-150 card-title font-weight-bold blog-card-title">{{ related.title }}</h3>
                  <p class="card-text text-secondary mb-3 line-clamp-2">{{ related.short_description }}</p>
                  <div class="d-flex flex-wrap align-items-center small text-muted mb-2">
                    <span class="mr-3">
                      <i class="fa-solid fa-user mr-1"></i>{{ related.author }}
                    </span>
                    <span class="mr-3">
                      <i class="fa-solid fa-calendar-alt mr-1"></i>{{ related.date }}
                    </span>
                  </div>
                  <!-- <span class="text-danger font-weight-bold">{{ related.readTime }}</span> -->
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- CTA Newsletter -->
      <div class="rounded p-5 text-center text-white blog-detail-cta">
        <h3 class="h4 font-weight-bold mb-3">¿Te ha resultado útil este artículo?</h3>
        <p class="mb-4 opacity-90">
          Suscríbete a nuestro newsletter para recibir más contenido como este
        </p>
        <router-link to="/contacto" class="btn btn-light text-danger font-weight-bold px-4">
          Suscribirme Ahora
        </router-link>
      </div>
    </article>

    <!-- Modal Compartir -->
    <b-modal v-model="showShareModal" title="Compartir artículo" hide-footer centered>
      <div class="d-flex flex-column">
        <button type="button" class="btn btn-outline-secondary btn-block mb-2 text-left">
          <i class="fa-brands fa-facebook mr-3 text-primary"></i>
          Compartir en Facebook
        </button>
        <button type="button" class="btn btn-outline-secondary btn-block mb-2 text-left">
          <i class="fa-brands fa-twitter mr-3 text-info"></i>
          Compartir en Twitter
        </button>
        <button type="button" class="btn btn-outline-secondary btn-block mb-2 text-left">
          <i class="fa-brands fa-linkedin mr-3 text-primary"></i>
          Compartir en LinkedIn
        </button>
        <button type="button" class="btn btn-outline-secondary btn-block text-left">
          <i class="fa-solid fa-envelope mr-3 text-secondary"></i>
          Enviar por Email
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'BlogDetailSection',
  data() {
    return {
      isLoading: true,
      id: null,
      article: {},
      relatedArticles: [],
      showShareModal: false,
    };
  },

  methods: {
    getContent() {
      this.isLoading = true;
      axios.get(tools.url('/api/blogs/' + this.id)).then((response) => {
        this.article = response.data.content;
        this.relatedArticles = response.data.related_articles;
        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
      });
    }
  },

  mounted() {
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getContent();
  },

  watch: {
    "$route.params.id" : function(v){
      this.id = this.$root._getURLID(this.$route.params.id);
      this.getContent();
    },
  },
};
</script>